<template>
    <div class="blackBg animate__animated animate__bounceIn">
        <div class="cardTit">
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
            <!--            <span class="userName">{{this.$route.params.name}}</span>-->
        </div>
        <div class="cardBg">
            <p class="userName">{{ this.$route.params.name }}</p>
            <div class="GPS-AIM-bar-content clearfix">
                <div class="contentBox">
                    <div class="barBox" :class="(item.name==checkName)?'scrollX':''" v-for="(item, index) in AIMItem">
                        <div :key="index" class="GPS-AIM-bar-item" :id="'GPS-AIM-bar-'+index"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "intensityReportDetail",
    data() {
        return {
            teamName: this.$store.state.teamName.split('_')[0],//梯队名称
            AIMData: [],
            AIMItem: [],
            checkName: '',//选中的标签 比如跑动距离
            time: null,//上下滚动定时器
            scrollDomHeight: 0,//dom高度
        }
    },
    computed: {
        lookCommandFn() {
            // return this.$store.state.lookCommand;
        },
        teamId() {
            return this.$store.state.teamId;
        }
    },
    watch: {},
    mounted() {
        this.getFilter()
    },
    methods: {
        //  获取gps 筛选项
        getFilter() {
            let data = {
                teamId: this.teamId
            }
            this.$server.getGpsFilter(data).then(res => {
                if (res.code === 200) {
                    this.AIMItem = [];
                    if (res.data && res.data.length) {
                        let arr = [];
                        res.data.map(item => {
                            if (item.intensity) {
                                // console.log(item.slug)
                                arr.push({
                                    ...item,
                                    playerNameAll: [],
                                    allData: [],
                                })
                            }

                        })
                        this.AIMItem = arr;
                        this.getAIM()
                    }
                }
            })
        },
        getAIM() {
            let data = {
                playerId: this.$route.params.id,
                teamId: this.teamId,
                year: new Date().getFullYear()
            }
            this.$server.getGPSAIMReport(data).then((res) => {
                if (res.code == 200) {
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.$route.params.name + '的强度报告'), true, false)

                    let AIMData = res.data;

                    this.weekData = [];
                    this.AIMItem.forEach((item, index) => {
                        item.allData = [];
                        item.increase = [];
                        if (index == 0) {
                            item.check = true;
                        } else {
                            item.check = false;
                        }
                    });

                    if (AIMData != null && AIMData != undefined && AIMData.length > 0) {

                        AIMData.forEach((item) => {
                            this.weekData.push(item.date.replace(/-/g, '/').substring(5))
                            this.AIMItem.forEach(gps => {
                                const currentGps = item.data.find(dataValue => dataValue.slug === gps.slug)
                                if (currentGps && currentGps.value) {
                                    gps.allData.push({
                                        value: Number(currentGps.value).toFixed(gps.decimal),
                                        timeFormat: gps.timeFormat,
                                        name: gps.displayName
                                    })
                                }else {
                                    gps.allData.push({
                                        value: '',
                                        timeFormat: 0,
                                        name: gps.displayName
                                    })
                                }
                            })
                        })


                        //默认显示
                        setTimeout(() => {
                            this.AIMItem.forEach((item, index) => {
                                this.AIMItem[index].check = true;
                                this.AIMBar(this.AIMItem[index], 'GPS-AIM-bar-' + index);
                            })

                            let setTime = setTimeout(() => {
                                const lookEl = document.querySelector('.GPS-AIM-bar-content');
                                const el = document.querySelector('.contentBox');
                                this.scrollDomHeight = el.offsetHeight - lookEl.offsetHeight;
                                console.log(this.scrollDomHeight);
                                if (this.scrollDomHeight > 0) {
                                    setTimeout(() => {
                                        this.scroll();
                                    }, )
                                    clearInterval(this.time)
                                    this.time = setInterval(this.scroll, 5500);
                                }
                                clearTimeout(setTime)
                            }, 100)
                        }, 500)
                    }
                }
            })
        },
        //echarts图
        AIMBar(data, id) {
            let dom = document.getElementById(id);
            let myChart = this.$echarts.init(dom);
            let lookDom = document.querySelector('#' + id)
            //柱状图显示宽度
            if (parseInt(lookDom.offsetWidth) > (60 * data.allData.length)) {
                dom.style.width = (parseInt(lookDom.offsetWidth) - 10) + 'px';
            } else {
                dom.style.width = (60 * data.allData.length) + "px";
            }
            myChart.resize();
            let option = null;

            option = {
                title: {
                    text: data.name,
                    textStyle: {
                        color: '#fff',
                        fontSize: 22,
                        fontWeight: null
                    },
                    left: '20',
                    top: '20'
                },
                color: ['#5FA0D7'],
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        // console.log(params)
                        // let html='<p>'+params[0].seriesName + '：' + params[0].value+'</p><p>上传次数：'+this.itemNum[params[0].dataIndex]+'</p>'
                        // return html;
                        // return params[0].seriesName + ':' + params[0].value;
                    }
                },
                grid: {
                    top: '25%',
                    left: '30',
                    right: '30',
                    bottom: '7%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        axisLine: {
                            show: true,  // 是否显示
                            lineStyle: {
                                color: '#666',
                                opacity: '0.5',
                                type: 'solid'
                            },
                        },
                        axisLabel: {
                            interval: 0,
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#666',
                                opacity: '0.3',
                                type: 'dotted'
                            },
                            show: false
                        },
                        data: this.weekData
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14,
                        },
                        axisLine: {
                            show: false,  // 是否显示
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#666',
                                opacity: '0.3',
                                type: 'dotted'
                            },
                            show: true
                        },
                    },
                ],
                series: [
                    {
                        name: data.name,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                barBorderRadius: [3, 3, 0, 0],
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 1,
                                    color: '#42A5F5'
                                },
                                    {
                                        offset: 0,
                                        color: '#2979FF'
                                    }])
                            }
                        },
                        label: {
                            show: true,
                            position: 'top',
                            rotate: '90',
                            align: 'left',
                            verticalAlign: 'middle',
                            distance: '10',
                            fontSize: 16,
                            textStyle: {
                                color: '#42A5F5'
                            },
                            formatter: (params) => {
                                if (params.data.timeFormat) {
                                    const time = Number(params.value)
                                    if (Number.isNaN(time)) {
                                        return ''
                                    } else {
                                        return this.$global.timeFormat(time)
                                    }
                                } else {
                                    return params.value
                                }
                            }
                        },
                        barWidth: 20,
                        data: data.allData
                    }
                ]
            };

            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }

        },
        //滚动数据
        scroll() {
            const el = document.querySelector('.contentBox');
            let style = el.getAttribute('style')
            if (style && style == 'margin-top:' + -(this.scrollDomHeight) + 'px') {
                el.setAttribute('style', 'margin-top:' + 0 + 'px')
            } else {
                el.setAttribute('style', 'margin-top:' + -(this.scrollDomHeight) + 'px')
            }
        }
    },
    destroyed() {
        clearInterval(this.time)
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    font-size: 30px;
    box-sizing: border-box;
    position: relative;

    .userName {
        font-family: PingFangMedium;
        color: #fff;
        display: inline-block;
        line-height: 120px;
        position: absolute;
    }

    .userName {
        right: 2vw;
        color: var(--primary-color);
        font-size: 36px;
    }
}

.cardBg {
    width: 100%;
    height: calc(100% - (120px + 1.2vw));
    padding: 1vw;
    box-sizing: border-box;
    overflow: hidden;

    .userName {
        color: var(--primary-color);
        font-size: 36px;
        height: 3vw;
        line-height: 2vw;
        padding-left: 1vw;
    }
}

.GPS-AIM-bar-content {
    width: 100%;
    height: calc(100% - 3vw);
    overflow-y: hidden;

    .contentBox {
        transition: all 5s linear;
        width: 100%;
        overflow-y: scroll;
    }

    .barBox {
        width: 100%;
        height: 400px;
        overflow-y: hidden;
        overflow-x: hidden;
        margin-top: 1.5vw;

        .GPS-AIM-bar-item {
            height: 100%;
            width: 100%;
        }
    }

    .scrollX {
        overflow-x: scroll;
    }
}
</style>
